module.exports = __webpack_public_path__ + "static/joyful_4-805af1d54a7ceee2dab82e7606f72062.jpg";